module.exports = __webpack_public_path__ + "img/woman-shopping-bags-drinking.cee85cd8.png";